import { Move } from './Move';

export class CollidedItem extends Move {
  item;
  box;
  collidedWith;
  isAsc = true;

  constructor (item, box, collidedWith) {
    super();
    this.item = item;
    this.box = box;
    this.collidedWith = collidedWith;
  }

  move () {
    this.item.box = this.box;
    this.setTextPositionY(this.item.label, this.box);
    this.setPathPositionY(this.item.label, this.box);
  }
}
